// From the finished job (the screenplay's cast and the recorded beats) to the scenes the Studio plays. Pure: the audio is passed in.
import { castMember } from "./cast";
import { stageStory } from "./staging";
import { newToonState } from "./render";

const FADE_IN = 0.4;                        // a new place gets a little more time: its first line starts after the cross-fade

// The screenplay again, as staging wants it: { cast, scenes: [{ setting, time, beats }] }.
export function screenplayOf(segments) {
  const cast = (segments.cast || []).map((m, i) => castMember(m, i));
  const scenes = [];
  (segments.scenes || []).forEach((beat) => {
    const n = beat.scene || 0;
    if (!scenes[n]) scenes[n] = { setting: beat.setting, time: beat.time, beats: [] };
    scenes[n].beats.push(beat);
  });
  return { cast, scenes: scenes.filter(Boolean) };
}

// The Studio scenes of a cartoon. `audio[i]` = { audioBuffer, analysis } of the i-th beat (or nothing).
export function buildToonScenes(segments, mode = "2d", audio = []) {
  const play = screenplayOf(segments);
  const staged = stageStory(play);
  const cast = Object.fromEntries(play.cast.map((c) => [c.id, c]));
  const blinks = newToonState(play.cast, 7);
  return staged.map((beat, i) => {
    const fresh = beat.sceneStart && i > 0;
    const sound = audio[i] || {};
    return {
      text: beat.text, caption: beat.text, seconds: beat.seconds + (fresh ? FADE_IN : 0), motion: "auto", transition: fresh ? "fade" : "cut",
      audioBuffer: sound.audioBuffer || null, analysis: sound.analysis || null, img: null, speaker: beat.speaker,
      toon: { mode, beat, cast, blinks },
    };
  });
}

export const speakerName = (segments, id) => (segments.cast || []).find((c) => c.id === id)?.name || "";
